import { useContext } from "react";
import { CreateInvoiceContext } from "../CreateInvoiceContext";

export function useCreateInvoiceContext() {
  const ctx = useContext(CreateInvoiceContext);
  if (!ctx) throw new Error("useCreateInvoiceContext must be used within <CreateInvoiceProvider />");
  return ctx;
}
